<template></template>
<script>
    export default {
        name: 'PaginationNoneLayout',
        mixins: [],
        components: {
        },
        inject: {
        },
        props: {
        },
        data() {
            return{
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods: {
        },
        watch: {
        },
    }
</script>
